import ProfileRelationshipsToMyExecutivesListReducer from './ProfileRelationshipsToMyExecutivesListReducer';

export default from './ProfileRelationshipsToMyExecutivesListContainer';
export const ProfileRelationshipsToMyExecutivesListReducers = {
  ProjectProfileRelationshipsToMyExecutivesListReducer: ProfileRelationshipsToMyExecutivesListReducer,
};
